import { Log } from "@scayle/storefront-core";
const levelMap = {
  error: 0,
  warn: 1,
  info: 3,
  debug: 4
};
function toConsolaLogLevel(level) {
  return levelMap[level];
}
export default function createLog(createConsola, space = "default-storefront", level) {
  const logger = createConsola({
    level: toConsolaLogLevel(level)
  });
  const handler = (entry) => {
    const data = entry.data;
    const log = logger[entry.level] || logger.info;
    const message = `[${entry.space}] ${entry.message}`;
    const args = data ? [message, data] : [message];
    log.apply(log, args);
  };
  return new Log({
    space,
    handler
  });
}
